import {CenaInStradaView} from "./cena-in-strada.view";
export default CenaInStradaView;
